<template>
  <div class="themecontainer" v-if="theme">
    <div class="theme">
      <div class="header pt-5 pb-3 px-3">
        <b-container>
          <b-row>
            <b-col>
              <router-link :to="{name: 'Challenges'}" id="backbutton"><icon name="arrow-left"/>{{ $t('challenges:browse-other-themes') }}</router-link>
            </b-col>
          </b-row>
          <b-row align-h="center">
            <b-col cols="12">
              <h1 id="theme-title" class="mt-3 mb-5 text-center">{{ theme.title }}</h1>
            </b-col>
            <b-col cols="12" md="8">
              <p id="theme-description" class="mt-3 mb-5">{{ theme.description }}</p>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <b-container id="list-of-challenges">
        <b-row v-for="m in theme.modules"  :key="m.id" align-h="center">
          <b-col cols="12" class="my-5">
            <h4 class="module-title mt-3 text-center">{{ m.title }}</h4>
          </b-col>
          <b-col cols="12" sm="12" md="12" lg="6" class="p-3" v-for="challenge in m.challenges" :key="challenge.id">
            <div class="card challenge-card h-100" :class="{'finished': challengeProgresses[challenge.id] && challengeProgresses[challenge.id].challengeFinished }" @click.stop="$router.push({ name: 'Challenge', params: { challengeId: challenge.id }})">
              <b-progress v-if="challengeProgresses[challenge.id] && challengeProgresses[challenge.id].challengeStarted === true" class="challenge-progress" height="0.5rem" :value="challengeProgresses[challenge.id].challengePageIndex + 1" :max="challenge.pages.length" ></b-progress>
              <div class="card-header border-light challenge-header text-center py-4 h-100">
                <div class="tag">{{ $t('challenges:'+challenge.type) }}</div>
                <h4 class="title">{{ challenge.title }}</h4>
              </div>
              <div class="card-footer border-light text-center">
                <b-button variant="link" :to="{ name: 'Challenge', params: { challengeId: challenge.id }}">{{$t('common:view')}}</b-button>
              </div>
            </div>
          </b-col>

          <b-col cols="12" sm="12" md="12" lg="6" class="p-3">
            <div class="card vote-card h-100" v-if="!votes[m.id]">
              <div class="card-header border-light challenge-header text-center p-0 h-100">
                <h5 class="title">{{ $t('challenges:feedback-request') }}</h5>
              </div>
              <div class="card-footer border-light text-center mb-3">
                <b-button variant="link" @click.stop="vote({theme: theme.title, themeId: theme.id, module: m.title, moduleId: m.id}, m.id)"><icon name="thumbs-up" scale="2" style="color: #fafafa"/></b-button>
              </div>
            </div>
            <div class="card vote-card answered h-100" v-else>
              <div class="card-header border-light challenge-header text-center pt-0 h-100">
                <h5 class="title mb-1">{{ $t('challenges:feedback-thank-you') }}</h5>
              </div>
              <div class="card-footer border-light text-center mb-4">
                <icon name="thumbs-up" scale="2"/>
              </div>
            </div>
          </b-col>

        </b-row>
        <b-row class="mt-5">
          <b-col class="text-center mb-5">
            <b-button variant="link" size="lg" :to="{name: 'Challenges'}"><icon name="arrow-left" style="margin-right: 0.5rem;"/>{{ $t('challenges:browse-other-themes') }}</b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <transition name="zoom" mode="in-out" enter-active-class="zoom-enter-active">
      <router-view @challenge-opened="challengeOpened"/>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ChallengeTheme',
  data () {
    return {
      theme: null,
      votes: {},
      challengeProgresses: {}
    }
  },
  watch: {
    language: {
      immediate: true,
      async handler (newVal, oldVal) {
        await this.loadChallengeTheme()
      }
    }
  },
  created: function () {
    this.$router.beforeEach((to, from, next) => {
      if (to.meta.transitionName === 'zoom') {
        document.body.style.overflow = 'hidden'
      }
      if (from.meta.transitionName === 'zoom') {
        document.body.style.overflow = 'auto'
      }
      next()
    })
  },
  async mounted () {
    this.loadChallengeThemeProgresses()
    await this.loadChallengeTheme()
  },
  methods: {
    challengeOpened: function (event) {
      document.body.style.overflow = 'hidden'
    },
    vote: function (data, id) {
      return new Promise((resolve, reject) => {
        this.axios.post('/feedback/challenge-vote', data).then(response => {
          this.votes[id] = true
          resolve()
          this.$forceUpdate()
        }).catch(err => {
          this.votes[id] = true
          this.$forceUpdate()
          reject(err)
        })
      })
    },
    loadChallengeTheme: function () {
      return new Promise((resolve, reject) => {
        const queriedLanguage = this.$store.state.language
        this.axios.get('/private/content/themes/' + this.$route.params.themeId + '/?lang=' + this.$store.state.language).then((response) => {
          // CLUDGE
          if (this.$store.state.language === queriedLanguage) {
            this.theme = response.data.theme
            this.theme.modules.forEach(m => {
              this.votes[m.id] = false
            })
            resolve()
          }
        }).catch(err => reject(err))
      })
    },
    loadChallengeThemeProgresses: function () {
      return new Promise((resolve, reject) => {
        this.axios.get(`/tracking/theme/${this.$route.params.themeId}`).then((response) => {
          this.challengeProgresses = response.data.progresses
          resolve()
        }).catch(err => reject(err))
      })
    }
  },
  computed: {
    ...mapGetters(['language'])
  }
}
</script>
<style lang="scss">
$bg-color: #377771;
$bg-text: #fafafa;
// $bg-gradient: radial-gradient(circle at bottom right, #4ce0b3, #377771);
$bg-gradient: radial-gradient(circle at bottom right, #ffaf87, #ed6a5e);
$secondary-text: #ffaf87;
$secondary-text2: #ff8e72;
$secondary-text3: #ed6a5e;

.themecontainer {
  background: #f5fcfd; // white;
}
.theme .header {
  background-repeat: no-repeat;
  background-image: $bg-gradient;
  color: $bg-text;
  background-size: cover;
  background-position: center;
  // height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-shadow: 0 0 2px rgba(white, 0.5);
  h5 {
    color: #20a8cc;
    font-size: 1em;
  }
  #theme-title {
    font-size: 3em;
    font-weight: 200;
  }
}

#theme-description {
  font-size: 1.25em;
}

.vote-card {
  background: $secondary-text2;
  color: #fafafa;
  &.answered {
    // border-color: #7eff8f;
    color: #1db76f;
    .btn-link {
      color: #1db76f;
    }
  }
  .card-header {
    background: none;
    border: none;
    .title {
      margin-top: 2rem;
      white-space: pre-line;
    }
  }
  .card-footer {
    background: none;
    border: none;
  }
}

.vote-card--light {
  @extend .vote-card;
  color: #fafafa;
  // background: var(--secondary); //sec2
  background: $secondary-text2;
  .btn-link {
    color: white;
  }
  &.answered {
    // border-color: #7eff8f;
    color: #7eff8f;
    .btn-link {
      color: #7eff8f;
    }
  }
}

.challenge-card {
  border: none; // 1px solid #a0e6f9;
  // border-radius: 6px;
  box-shadow: 0 2px 3px rgba(black, 0.12);
  cursor: pointer;
  // position: relative;

  &.finished {
    // border: 1px solid #28c551;

    .challenge-header {
      background-image: $bg-gradient;
      color: $bg-text;
      background-repeat: no-repeat;
    }
  }

  .card-footer {
    background: white;
  }
  .tag {
    text-transform: uppercase;
    letter-spacing: 1px;
    font-size: 0.8em;
    font-weight: bold;
    margin-bottom: 1rem;
    color: $bg-color; //sec2
  }
  .title {
    font-size: 1.25em;
    font-weight: bold;
  }
  &.locked::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: url('/img/premium-locked.svg'), rgba(#20a8cc, 0.33);
    background-size: auto 2em;
    background-repeat: no-repeat;
    background-position: 1em 1em;
  }
  .challenge-header {
    // background-color: $bg-color;
    background-image: $bg-gradient;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: $bg-text;
    padding: 2rem;
    h5 {
      color: $bg-color; //sec2
      font-size: 1em;
    }
  }
}

.module-title {
  color: #5b8590; // #20a8cc;
}

#backbutton {
  cursor: pointer;
  margin-bottom: 1em;
  color: $bg-color; //sec2
  .fa-icon {
    margin-right: 0.5em;
    vertical-align: baseline;
    font-size: 12px;
  }
}
</style>
